const GIFT_CARD_ALIAS = {
  paytronix: 'giftCard',
  square: 'GIFT_CARD',
};

/**
 *
 * @param lineItem Line item coming from the square check.
 * @returns String representing the lineItem's catalog id or 'giftCard' for gift card purchases
 */
export function getItemId(lineItem) {
  if (lineItem?.itemType?.toUpperCase() === GIFT_CARD_ALIAS.square) {
    return GIFT_CARD_ALIAS.paytronix;
  }

  return lineItem.catalogObjectId ?? '';
}
